type AirshipHorizontalIconProps = React.SVGProps<SVGSVGElement>;

const AirshipHorizontalIcon: React.FC<AirshipHorizontalIconProps> = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 560 216.04"
    {...props}
  >
    <defs>
      <style>{`.cls-1{fill:#be1624;stroke-width:0px;}`}</style>
    </defs>
    <path
      className="cls-1"
      d="M207.99,122.18h-15.72l-2.92,7.28h-11.89l16.63-43.33h12.28l16.31,43.33h-12.02l-2.66-7.28ZM205,113.61l-4.87-14.03-4.74,14.03h9.61Z"
    />
    <path className="cls-1" d="M248.19,86.13v43.33h-11.24v-43.33h11.24Z" />
    <path
      className="cls-1"
      d="M284.72,86.13c3.25,0,7.41.52,10.59,3.83,2.47,2.53,3.7,6.3,3.7,9.74,0,3.7-1.3,6.95-3.44,9.03-1.69,1.62-3.96,2.6-5.98,2.99l13.58,17.74h-13.97l-10.78-16.63v16.63h-11.24v-43.33h17.54ZM278.42,105.55h2.14c1.69,0,4.09-.45,5.46-1.75.84-.84,1.43-2.27,1.43-3.64s-.52-2.73-1.49-3.64c-1.04-1.04-2.92-1.69-5.39-1.69h-2.14v10.72Z"
    />
    <path
      className="cls-1"
      d="M320.15,116.47c2.4,2.27,6.04,4.42,9.94,4.42,2.27,0,3.64-.72,4.35-1.49.65-.65,1.1-1.62,1.1-2.73,0-.84-.33-1.82-1.23-2.6-1.1-.97-2.79-1.43-5.59-2.27l-2.92-.91c-1.82-.58-4.48-1.56-6.24-3.51-2.21-2.4-2.47-5.46-2.47-7.67,0-5.33,2.08-8.58,3.96-10.46,2.21-2.21,5.85-4.09,11.11-4.09,4.29,0,9.29,1.36,13.38,3.51l-4.48,8.77c-3.38-2.66-5.91-2.92-7.41-2.92-1.1,0-2.6.26-3.7,1.3-.65.65-1.1,1.36-1.1,2.34,0,.78.13,1.36.58,1.95.33.39,1.1,1.17,3.77,1.95l3.44,1.04c2.73.84,5.59,1.82,7.86,4.29,2.21,2.34,2.79,4.74,2.79,7.73,0,3.96-.97,7.8-4.09,10.91-3.7,3.7-8.18,4.42-12.8,4.42-2.73,0-5.33-.26-8.51-1.43-.72-.26-3.44-1.3-6.56-3.44l4.81-9.1Z"
    />
    <path
      className="cls-1"
      d="M375.42,102.3h16.24v-16.18h11.3v43.33h-11.3v-17.54h-16.24v17.54h-11.24v-43.33h11.24v16.18Z"
    />
    <path className="cls-1" d="M433.29,86.13v43.33h-11.24v-43.33h11.24Z" />
    <path
      className="cls-1"
      d="M463.52,115.1v14.36h-11.24v-43.33h17.93c3.77,0,7.67.71,10.98,3.9,3.38,3.25,4.03,6.89,4.03,10.52,0,3.44-.45,7.47-3.83,10.78-3.38,3.31-7.41,3.77-10.78,3.77h-7.08ZM463.52,106.01h3.77c1.17,0,3.38-.13,4.74-1.36,1.37-1.17,1.43-2.92,1.43-3.96,0-1.17-.13-2.73-1.3-3.9-1.3-1.36-3.38-1.56-4.81-1.56h-3.83v10.78Z"
    />
    <path
      className="cls-1"
      d="M111.11,95.17l-11.72,25.64-3.29,7.43c4.58,2.08,9.65,3.25,15.01,3.25s10.06-1.08,14.51-3.02l-3.32-7.66-11.18-25.64Z"
    />
    <path
      className="cls-1"
      d="M135.02,122.49c7.6-6.66,12.4-16.42,12.4-27.32,0-20.06-16.26-36.32-36.32-36.32s-36.32,16.26-36.32,36.32c0,10.74,4.66,20.38,12.07,27.03l24.45-52.52,23.72,52.81Z"
    />
    <path
      className="cls-1"
      d="M125.61,128.46l1.32,3.04,7.91,18.31h12.45l-12.28-27.33c-2.79,2.45-5.96,4.47-9.41,5.98Z"
    />
    <path
      className="cls-1"
      d="M73.99,149.82h12.26l8.4-18.31,1.45-3.26c-3.39-1.54-6.51-3.58-9.25-6.04l-12.86,27.62Z"
    />
  </svg>
);

export default AirshipHorizontalIcon;
